module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dashboard-widget', {
    staticClass: "leads-over-time",
    attrs: {
      "is-loading": _vm.isLoading,
      "is-loading-spinner": ""
    }
  }, [
    [_c('div', {
      staticClass: "dark-charts m-bottom-base"
    }, [_c('h4', {}, [_vm._v(_vm._s(_vm.$t('ui.dashboard.leads_over_time.label')))]), _vm._v(" "), _c('div', {
      ref: _vm.identifier,
      staticStyle: {
        "height": "182px"
      },
      attrs: {
        "id": _vm.identifier
      },
      on: {
        "mouseleave": function($event) {
          return _vm.setItVisibleTooltip(false)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "dashboard-tooltip",
      style: (_vm.tooltip)
    }, [_c('span', {
      staticClass: "new"
    }, [_vm._v(_vm._s(_vm.chart.tooltip.leads) + " " + _vm._s(_vm.$t('ui.dashboard.leads_over_time.linear')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "cumulated"
    }, [_vm._v(_vm._s(_vm.chart.tooltip.cumulative) + " " + _vm._s(_vm.$t('ui.dashboard.leads_over_time.cumulated')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "date"
    }, [_vm._v(_vm._s(_vm._f("format")(_vm.chart.tooltip.date, 'en', _vm.filter.period)))])]), _vm._v(" "), _c('leads-collected-widget', {
      attrs: {
        "filter": _vm.filter
      }
    })]
  ], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a5c8bfc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/dashboard/widgets/widgets/LeadsOverTimeWidget.vue
// module id = 1913
// module chunks = 0